import { BASE_URL, MOBILE_BASE_URL } from "../api_const";


export const UPLOAD_FILE = BASE_URL + "/upload"
export const GET_ADDRESS_DETAILS_BY_LAT_LNG = "https://ba.energymarketplace.in/mobile-service/api/v1" + "/getaddress"
export const URL_STATES = BASE_URL + "/country-master/states"